import React from "react";
import { makeStyles } from "@fluentui/react-components";
import "../css/DropDown.css";
import { DropdownMenu } from "./DropdownMenu";
import {
  activeCapabilityType,
  capabilityType,
  MenuItemData,
} from "../types/CommonTypes";

const useStyles = makeStyles({
  icon: {
    width: "32px",
    height: "32px",
  },
});

interface DropDownProps {
  activeCapability: activeCapabilityType | undefined;
  capabilitiesList: capabilityType[];
  onSelect: (
    capabilityname: string,
    capabilityId: string,
    capabilityDomain: string
  ) => void;
}

export const DropDownNavigation: React.FC<DropDownProps> = ({
  capabilitiesList,
  activeCapability,
  onSelect,
}) => {
  const styles = useStyles();

  const menuItems: MenuItemData[] = Array.isArray(capabilitiesList)
    ? capabilitiesList.map((capability) => ({
        domain: capability.capabilityDomain,
        key: capability.capabilityId,
        text: capability.capabilityName,
        icon: (
          <img
            src={capability.capabilityImage || ""}
            alt={capability.capabilityName}
            className={styles.icon}
          />
        ),
      }))
    : [];

  const handleSelectionChange = (item: MenuItemData) => {
    onSelect(item.text, item.key, item.domain);
  };

  return (
    <div>
      <DropdownMenu
        menuItems={menuItems}
        defaultValue={activeCapability?.capabilityDetails.capabilityId}
        onSelect={handleSelectionChange}
      />
    </div>
  );
};
